export const CALLBACK_URL_PARAM = 'redirectTo';
export const SOCIAL_AUTH_EVENT_PARAM = 'socialAuthEvent';
export const SOCIAL_AUTH_PROVIDER_PARAM = 'socialAuthProvider';
